import React from 'react';

import { Skeleton } from 'antd';
import { Breadcrumb } from 'farmhub-ui-core';
import { matchPath } from 'react-router';
import { useHistory, withRouter } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app';
import {
  defaultModuleRoutes,
  defaultOrderRoutes,
  routes,
} from 'containers/App/utils/route';
import { loadingBreadcrumb, selectAccount, selectBreadcrumb } from 'slice';
import { isEmptyString } from 'utils';

import { CBreadcrumbItem, Wrapper } from './styles';

const AppBreadcrumb = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const breadcrumb = useAppSelector(selectBreadcrumb);
  const account = useAppSelector(selectAccount);
  const canCreateNewProduct = useAppSelector(
    state => state.account.item?.canCreateNewProduct
  );

  const renderData = React.useCallback(() => {
    const result: any[] = [
      {
        title: 'Trang chủ',
        route: '/',
      },
    ];

    if (history.location.pathname == '/') {
      return result;
    }

    let route: any = {};

    routes(canCreateNewProduct, account.permissions).forEach((item: any) => {
      const match = matchPath(history.location.pathname, item);

      if (match) {
        route = match;
        return false;
      }

      return true;
    });

    const routeLabel: any = routes(
      canCreateNewProduct,
      account.permissions
    ).find((item: any) => item.path == route.path);

    const titles = (routeLabel?.label ?? '')?.split('/');

    if (history.location.pathname.includes('/section/create')) {
      const index = (routeLabel?.path ?? '')
        .split('/')
        .slice(1)
        .findIndex((item: string) => item == ':id');

      const originPathname = history.location.pathname.replace(
        '/section/create',
        ''
      );
      const arrOriginPathname = originPathname.split('/').slice(1);

      for (let i = 0; i < titles.length; i++) {
        const convertRoute =
          i == index
            ? `${arrOriginPathname
                .slice(0, i + 1)
                .join('/')}/detail?tab=sections`
            : arrOriginPathname.slice(0, i + 1).join('/');

        result.push({
          title: titles[i],
          route: defaultModuleRoutes[convertRoute]
            ? `/${defaultModuleRoutes[convertRoute]}`
            : `/${convertRoute}`,
        });
      }

      result.push({
        title: 'Thêm mới',
        route: '',
      });

      return result;
    }

    if (history.location.pathname.includes('/section/sync')) {
      const index = (routeLabel?.path ?? '')
        .split('/')
        .slice(1)
        .findIndex((item: string) => item == ':id');

      const originPathname = history.location.pathname.replace(
        '/section/sync',
        ''
      );
      const arrOriginPathname = originPathname.split('/').slice(1);

      for (let i = 0; i < titles.length; i++) {
        const convertRoute =
          i == index
            ? `${arrOriginPathname
                .slice(0, i + 1)
                .join('/')}/detail?tab=sections`
            : arrOriginPathname.slice(0, i + 1).join('/');

        result.push({
          title: titles[i],
          route: defaultModuleRoutes[convertRoute]
            ? `/${defaultModuleRoutes[convertRoute]}`
            : `/${convertRoute}`,
        });
      }

      result.push({
        title: 'Đồng bộ',
        route: '',
      });

      return result;
    }

    if (history.location.pathname.includes('/section/update')) {
      const index = (routeLabel?.path ?? '')
        .split('/')
        .slice(1)
        .findIndex((item: string) => item == ':id');

      const originPathname = history.location.pathname.replace(
        '/section/create',
        ''
      );
      const arrOriginPathname = originPathname.split('/').slice(1);

      for (let i = 0; i < titles.length; i++) {
        const convertRoute =
          i == index
            ? `${arrOriginPathname
                .slice(0, i + 1)
                .join('/')}/detail?tab=sections`
            : arrOriginPathname.slice(0, i + 1).join('/');

        result.push({
          title: titles[i],
          route: defaultModuleRoutes[convertRoute]
            ? `/${defaultModuleRoutes[convertRoute]}`
            : `/${convertRoute}`,
        });
      }

      result.push({
        title: breadcrumb.isLoading ? (
          <Skeleton.Input size="small" style={{ width: 100 }} />
        ) : (
          breadcrumb.title
        ),
        route: '',
      });

      return result;
    }

    if (history.location.pathname.includes('/create')) {
      const originPathname = history.location.pathname.replace('/create', '');
      const arrOriginPathname = originPathname.split('/').slice(1);

      for (let i = 0; i < titles.length; i++) {
        const convertRoute =
          i == titles.length - 1
            ? `${arrOriginPathname.slice(0, i + 1).join('/')}/list`
            : arrOriginPathname.slice(0, i + 1).join('/');

        result.push({
          title: titles[i],
          route: defaultModuleRoutes[convertRoute]
            ? `/${defaultModuleRoutes[convertRoute]}`
            : `/${convertRoute}`,
        });
      }

      result.push({
        title: 'Thêm mới',
        route: '',
      });

      return result;
    }

    if ((routeLabel?.path ?? '').includes('/:id/detail')) {
      const originPathname = history.location.pathname.replace(
        '/:id/detail',
        ''
      );
      const arrOriginPathname = originPathname.split('/').slice(1);

      for (let i = 0; i < titles.length; i++) {
        const convertRoute =
          i == titles.length - 1
            ? defaultOrderRoutes.includes(
                arrOriginPathname.slice(0, i + 1).join('/')
              )
              ? arrOriginPathname.slice(0, i + 1).join('/')
              : `${arrOriginPathname.slice(0, i + 1).join('/')}/list`
            : arrOriginPathname.slice(0, i + 1).join('/');

        result.push({
          title: titles[i],
          route: defaultModuleRoutes[convertRoute]
            ? `/${defaultModuleRoutes[convertRoute]}`
            : `/${convertRoute}`,
        });
      }

      result.push({
        title: breadcrumb.isLoading ? (
          <Skeleton.Input size="small" style={{ width: 100 }} />
        ) : (
          breadcrumb.title
        ),
        route: '',
      });

      return result;
    }

    if ((routeLabel?.path ?? '').includes('/:id/update')) {
      const originPathname = history.location.pathname.replace(
        '/:id/update',
        ''
      );
      const arrOriginPathname = originPathname.split('/').slice(1);

      for (let i = 0; i < titles.length; i++) {
        const convertRoute =
          i == titles.length - 1
            ? defaultOrderRoutes.includes(
                arrOriginPathname.slice(0, i + 1).join('/')
              )
              ? arrOriginPathname.slice(0, i + 1).join('/')
              : `${arrOriginPathname.slice(0, i + 1).join('/')}/list`
            : arrOriginPathname.slice(0, i + 1).join('/');

        result.push({
          title: titles[i],
          route: defaultModuleRoutes[convertRoute]
            ? `/${defaultModuleRoutes[convertRoute]}`
            : `/${convertRoute}`,
        });
      }

      result.push({
        title: breadcrumb.isLoading ? (
          <Skeleton.Input size="small" style={{ width: 100 }} />
        ) : (
          breadcrumb.title
        ),
        route: '',
      });

      return result;
    }

    if ((routeLabel?.path ?? '').includes('/:id/crm')) {
      const originPathname = history.location.pathname.replace('/:id/crm', '');
      const arrOriginPathname = originPathname.split('/').slice(1);

      for (let i = 0; i < titles.length; i++) {
        const convertRoute =
          i == titles.length - 1
            ? defaultOrderRoutes.includes(
                arrOriginPathname.slice(0, i + 1).join('/')
              )
              ? arrOriginPathname.slice(0, i + 1).join('/')
              : `${arrOriginPathname.slice(0, i + 1).join('/')}/list`
            : arrOriginPathname.slice(0, i + 1).join('/');

        result.push({
          title: titles[i],
          route: defaultModuleRoutes[convertRoute]
            ? `/${defaultModuleRoutes[convertRoute]}`
            : `/${convertRoute}`,
        });
      }

      result.push({
        title: breadcrumb.isLoading ? (
          <Skeleton.Input size="small" style={{ width: 100 }} />
        ) : (
          breadcrumb.title
        ),
        route: '',
      });

      result.push({
        title: 'CRM',
        route: '',
      });

      return result;
    }

    if (history.location.pathname.includes('/history')) {
      const originPathname = history.location.pathname.replace('/history', '');
      const arrOriginPathname = originPathname.split('/').slice(1);

      for (let i = 0; i < titles.length; i++) {
        const convertRoute =
          i == titles.length - 1
            ? `${arrOriginPathname.slice(0, i + 1).join('/')}/list`
            : arrOriginPathname.slice(0, i + 1).join('/');

        result.push({
          title: titles[i],
          route: defaultModuleRoutes[convertRoute]
            ? `/${defaultModuleRoutes[convertRoute]}`
            : `/${convertRoute}`,
        });
      }

      result.push({
        title: 'Lịch sử',
        route: '',
      });

      return result;
    }

    if (history.location.pathname.includes('/overview')) {
      const originPathname = history.location.pathname.replace('/overview', '');
      const arrOriginPathname = originPathname.split('/').slice(1);

      for (let i = 0; i < titles.length; i++) {
        const convertRoute =
          i == titles.length - 1
            ? defaultOrderRoutes.includes(
                arrOriginPathname.slice(0, i + 1).join('/')
              )
              ? arrOriginPathname.slice(0, i + 1).join('/')
              : `${arrOriginPathname.slice(0, i + 1).join('/')}/list`
            : arrOriginPathname.slice(0, i + 1).join('/');

        result.push({
          title: titles[i],
          route: defaultModuleRoutes[convertRoute]
            ? `/${defaultModuleRoutes[convertRoute]}`
            : `/${convertRoute}`,
        });
      }

      result.push({
        title: 'Tổng quan',
        route: '',
      });

      return result;
    }

    if (
      history.location.pathname.includes('/sync') &&
      !history.location.pathname.includes('/sync-menu')
    ) {
      const originPathname = history.location.pathname.replace('/sync', '');
      const arrOriginPathname = originPathname.split('/').slice(1);

      for (let i = 0; i < titles.length; i++) {
        const convertRoute =
          i == titles.length - 1
            ? `${arrOriginPathname.slice(0, i + 1).join('/')}/list`
            : arrOriginPathname.slice(0, i + 1).join('/');

        result.push({
          title: titles[i],
          route: defaultModuleRoutes[convertRoute]
            ? `/${defaultModuleRoutes[convertRoute]}`
            : `/${convertRoute}`,
        });
      }

      result.push({
        title: 'Đồng bộ',
        route: '',
      });

      return result;
    }

    const arrOriginPathname = history.location.pathname.split('/').slice(1);

    for (let i = 0; i < titles.length; i++) {
      const convertRoute =
        i != titles.length - 1
          ? arrOriginPathname.slice(0, i + 1).join('/')
          : '';

      result.push({
        title: titles[i],
        route: defaultModuleRoutes[convertRoute]
          ? `/${defaultModuleRoutes[convertRoute]}`
          : convertRoute,
      });
    }

    return result;
  }, [breadcrumb]);

  React.useEffect(() => {
    if (!breadcrumb.isLoading) {
      dispatch(loadingBreadcrumb());
    }
  }, [history.location.pathname]);

  return (
    <Wrapper>
      <Breadcrumb>
        {renderData().length > 1 ? (
          renderData().map((item: any, index: number) => (
            <CBreadcrumbItem
              hasRoute={
                !isEmptyString(item.route) && index < renderData().length - 1
              }
              onClick={() => {
                if (
                  !isEmptyString(item.route) &&
                  index < renderData().length - 1
                ) {
                  history.push(item.route);
                }
              }}
            >
              {item.title}
            </CBreadcrumbItem>
          ))
        ) : (
          <></>
        )}
      </Breadcrumb>
    </Wrapper>
  );
};

export default withRouter(AppBreadcrumb);
